export const INITIAL_DRAWING_STATE = {
    isDrawing: false,
    startX: 0,
    startY: 0,
    currentX: 0,
    currentY: 0,
    tool: null,
};
export function isBoxDrawingTool(tool) {
    return tool === 'rectangle' || tool === 'circle' || tool === 'triangle';
}
export function isShapeDrawingTool(tool) {
    return isBoxDrawingTool(tool) || tool === 'curve';
}
export function isPlacementOrDrawingTool(tool) {
    return (tool === 'text' ||
        tool === 'line' ||
        tool === 'rectangle' ||
        tool === 'circle' ||
        tool === 'triangle' ||
        tool === 'curve' ||
        tool === 'polygon');
}
